import React, { useState } from 'react';
import {
  Paper,
  Chip,
  Button,
  Link as MLink,
} from '@mui/material';
import {
  Link as RouterLink,
  MemoryRouter,
} from 'react-router-dom';
import { useNavigate } from "react-router-dom";
//import Button from 'react-bootstrap/Button';
//import Col from 'react-bootstrap/Col';
//import Form from 'react-bootstrap/Form';
//import Alert from 'react-bootstrap/Alert';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import { Link, Navigate, useParams } from "react-router-dom";
//import Form, { EmptyItem, GroupItem, Label, SimpleItem } from 'devextreme-react/form';
import 'devextreme-react/text-area';
import 'devextreme-react/select-box';

import Form, {
  ButtonItem,
  GroupItem,
  SimpleItem,
  Label,
  CompareRule,
  EmailRule,
  PatternRule,
  CustomRule,
  RangeRule,
  RequiredRule,
  StringLengthRule,
  AsyncRule,
  Item,
  EmptyItem,
} from 'devextreme-react/form';
import notify from 'devextreme/ui/notify';
import 'devextreme-react/autocomplete';

import utils from '../utils'
import AuthService from '../services/auth-service';
import LoadingSpinner from '../comp/gen/LoadingSpinner';
import UserAuthRequired from '../comp/gen/UserAuthRequired';
import Badge from '@mui/material/Badge';

import TextBox from 'devextreme-react/text-box';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import PropTypes from 'prop-types';

import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Stack from '@mui/material/Stack';
import CheckBox from "devextreme/ui/check_box"

// ************************************************************
// ************************************************************
// ************************************************************

// TEST URL : http://localhost:3000/_car/_r/ecu-helper/computer/add?b=eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2NvZGUiOiIwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDExIiwiaXNzIjoic2VydmljZWFwcGxpY2F0aW9ucy5uZXQiLCJleHAiOjE2Nzk0OTc3OTksInByb2dyYW1fc2VsZWN0b3IiOiJjYW50b29sMl9hZG1pbiIsInByb2dyYW1fbmFtZSI6IkNhblRvb2xBZG1pbiJ9.F138TwEz7hvLg_czZPrvGe1G-m1J7gVna4VkIqXIl94zP9dk-6VwWCWwIFxIH0EVUEjAgEf8AYbJu3wKh5MopD0MsACoJF-OpdSgizCejipkhla3tftRl_-i9FQSpxmdHHKVAsCdRQA_VzHoB4WudJrqSWB6Z1XnaXEu6KjiIiooGeP5zM8utqRaMlrFY-YbEyKhnR6SmXMGzr8c-Y6TsLYX6qBKAFy3GDI3P_Jt-YHsce1glLNSjq0p1olbnjo8WDonZrmNDFNkG8IseTfWzBLMUAy0meTN4BP_hkJSzr13VXcxyeZ_XMGmyuH7defq0on9YuD2o0wyLEA5YfRgnawxIrZQ7XD-tMIP6-5Qqxdt9MoIxys6Q54VlVRanbha3ThmkosWbrAnD3iJvPvVA0SKdjIyiXCjCQ6AUavaYBfqbhTGiF5rnweSw0cuXoWE0kq9duZOSMQmsV018OoKZkdjZk-VdJw0pcX4c2vu6exBo59Se1YNEy4ZOQRt5bHhIWZ0cSC9qY4YNLSIsLVD8jiOyOiz1uj1E7B62UkiSGmisGEd_Yn4RQFH5_ifrI0SWBwYVtr2Vk80abV5_trhHxSztiAPrXlrggP0nvkma2J24gsxUJIuDK4d4MIolsLob-3H42vh-_trm4RviLfa3iWI8Qtsu7R4wFfIdXrlBpE

// elenco countries+state+cities:
// https://github.com/dr5hn/countries-states-cities-database
// https://github.com/dr5hn/countries-states-cities-database/blob/master/countries%2Bstates%2Bcities.json
import _COUNTRIES from '../services/countries_states_cities'

// ************************************************************
// ************************************************************
// ************************************************************

export const NotActivatedString = "not activated"

export default class ServiceUserForm extends React.Component {
  constructor(props) {
    super(props);
    
    if (props.newUser === true) {
      console.log("new user")      
    } else if (props.isReseller) {
      // si e' loggato un reseller
      console.log("is reseller")      
    } else if (props.user.is_reseller) {
      // l'utente selezionato e' un reseller
      console.log("user is reseller")      
    } else if (props.isAdmin) {
      console.log("is admin")      
    } else {
      console.log("else...")      
    }

    this.state = {
      cities: [],
      cities_view: [],
      states: [],
      states_view: [],      
    }
    this.form = React.createRef()
  }
  componentDidMount() {
    this.loadCities()    
  }
  loadCities() {
    var states = []
    var states_view = []
    var cities = []
    var cities_view = []
    if (this.props.user.company_country) {
      var country_name = this.props.user.company_country
      states = _COUNTRIES.find(item => item.name == country_name)?.states || []
      states_view = [].concat("NONE", states.map(item => item.name))
      //console.log("states_view", states_view)
      if (this.props.user.company_state) {
        var city_name = this.props.user.company_state
        cities = states.find(item => item.name == city_name)?.cities || []
        cities_view = [].concat("NONE", cities.map(item => item.name))
        //console.log("cities_view", cities_view)
      }
    }
    this.setState({
      states: states,
      states_view: states_view,
      cities: cities,
      cities_view: cities_view,
    })
    // var country_name = "Italy"
    // var city_name = "Veneto"
    // var states = _COUNTRIES.find(item => item.name == country_name)?.states || []
    // var cities = states.find(item => item.name == city_name)?.cities || []
    // console.log("states", states.map(item => item.name))
    // console.log("cities", cities.map(item => item.name))
  }
  readOnlyForResellersAndForUser() {
    if (this.props.readOnly) return true
    if (!this.props.isReseller && !this.props.isAdmin) return true // utente
    if (this.props.isReseller) return true // reseller
    return false // admin
  }
  readOnlyForResellersButNotForUser() {
    if (this.props.readOnly) return true
    if (!this.props.isReseller && !this.props.isAdmin) return false // utente
    if (this.props.isReseller) return true // reseller
    return false // admin
  }
  render() {
    return (
      <form autoComplete="off">
        <Form
          ref={this.form}
          formData={this.props.user}
          readOnly={false}
          showColonAfterLabel={true}
          //showValidationSummary={true}
          labelLocation="left"
          minColWidth={300}
          colCount={2}
          validationGroup="userDataValidationGroup" >

          {this.credentialFormItems()}
          {this.userFormItems()}
          {this.companyFormItems()}
          {this.props.newUser ? this.acceptFormItems() : this.informationFormItems()}

        </Form>
        {this.renderButtons()}
      </form>
    )
  }

  credentialFormItems() {
    return (
      <GroupItem caption="Credentials">

        {/* USERNAME */}
        {this.props.newUser ? (
          <SimpleItem
            dataField="username"
            editorType="dxTextBox"
            editorOptions={{
              readOnly: false,
              inputAttr: {
                autocomplete: "new-username",
              },
            }} >
            <StringLengthRule
              min={5}
              message="Username must have at least 5 symbols" />
            <RequiredRule message="Username is required" />
            <PatternRule
              message="Allowed letters and numbers only"
              pattern={/^[a-zA-Z0-9]*$/} />
          </SimpleItem>
        ) : (
          <SimpleItem
            dataField="username"
            editorType="dxTextBox"
            editorOptions={{
              readOnly: this.readOnlyForResellersAndForUser(),
              inputAttr: {
                autocomplete: "new-username",
              },
            }} >
            <StringLengthRule
              min={5}
              message="Username must have at least 5 symbols" />
            <RequiredRule message="Username is required" />
            <PatternRule
              message="Allowed letters and numbers only"
              pattern={/^[a-zA-Z0-9]*$/} />
          </SimpleItem>
        )}

        {/* LR USER CODE */}
        <SimpleItem
          dataField="LR_user_code"
          editorType="dxTextBox"
          editorOptions={{
            readOnly: this.props.readOnly,       
          }} >
          <Label text="LR user code" />
          {/* <RequiredRule message="LR user code is required" /> */}
          <PatternRule
            message="Allowed letters, numbers and spaces only"
            pattern={/^[a-zA-Z0-9 _]*$/} />
        </SimpleItem>
        
        {/* SUPPLIER NAME */}
        <SimpleItem
          dataField="supplier_name"
          editorOptions={{
            readOnly: this.props.readOnly,
          }} >          
          {/* <RequiredRule message="Supplier name is required" /> */}
          <PatternRule
            message="Allowed letters, numbers and spaces only"
            pattern={/^[a-zA-Z0-9 _]*$/} />
        </SimpleItem>

        <EmptyItem />

        {/* PASSWORD */}
        {!this.props.readOnly && (
          <SimpleItem
            dataField="password"
            editorType="dxTextBox"
            editorOptions={{
              mode: 'password',
              inputAttr: {
                autocomplete: "new-password"
              },
            }} >
            <StringLengthRule
              ignoreEmptyValue={!this.props.newUser}
              min={8}
              message="Password must have at least 8 symbols" />
            <PatternRule
              message="Allowed letters and numbers only"
              pattern={/^[a-zA-Z0-9]*$/} />
            {/* <CustomRule
              message="Password and Confirm password do not match"
              reevaluate={true}
              type="custom"
              validationCallback={(e) => this.validatePassword(e, this.props.user.confirm_password)} /> 

              TODO: questo sembra non andare, valida qui quando ancora non c'e' la confirm e poi non lo rivaluta quando metto la confirm ...
              */}
          </SimpleItem>
        )}

        {/* CONFIRM PASSWORD */}
        {!this.props.readOnly && (
          <SimpleItem
            dataField="confirm_password"
            editorType="dxTextBox"
            editorOptions={{
              mode: 'password',
            }} >
            <Label text="Confirm password" />
            <StringLengthRule
              ignoreEmptyValue={!this.props.newUser}
              min={8}
              message="Password must have at least 8 symbols" />            
            <PatternRule
              message="Allowed letters and numbers only"
              pattern={/^[a-zA-Z0-9]*$/} />
            <CustomRule
              message="Password and Confirm password do not match"
              reevaluate={true}
              type="custom"
              validationCallback={(e) => this.validatePassword(e, this.props.user.password)} />
          </SimpleItem>
        )}

        {!this.props.readOnly && (
          <EmptyItem />
        )}

        {/* NOTES */}
        {!this.props.newUser && (
          <SimpleItem
            dataField="note"
            editorType="dxTextArea"
            editorOptions={{
              height: 75,
              readOnly: this.props.readOnly,
            }} >
            <Label text="Notes" />
          </SimpleItem>
        )}

      </GroupItem>
    )
  }
  userFormItems() {
    var hide_admin_options = true
    if (this.props.newUser) {
      // questa vince su tutti
    } else if (this.props.isAdmin) {
      hide_admin_options = false
    } else {
      // in tutti gli altri casi non li faccio vedere
    }
    
    return (
      <GroupItem caption="User">
        <SimpleItem
          dataField="first_name"
          editorOptions={{
            readOnly: this.props.readOnly,
          }} >
          <RequiredRule message="First name is required" />
          <PatternRule
            message="Do not use digits in the name"
            pattern={/^[^0-9]+$/} />
        </SimpleItem>
        <SimpleItem
          dataField="last_name"
          editorOptions={{
            readOnly: this.props.readOnly,
          }} >
          <RequiredRule message="Last name is required" />
          <PatternRule
            message="Do not use digits in the name"
            pattern={/^[^0-9]+$/} />
        </SimpleItem>        
        <SimpleItem
          dataField="email"
          editorType="dxTextBox"
          editorOptions={{
            mode: 'email',
            readOnly: this.props.readOnly,
          }} >
          <RequiredRule message="Email is required" />
          <EmailRule message="Email is invalid" />
          {/* <AsyncRule
            message="Email is already registered"
            validationCallback={asyncValidation} /> */}
        </SimpleItem>
        <SimpleItem
          dataField="phone"
          editorType="dxTextBox"
          helpText="ex. +3905221234"
          editorOptions={{
            mode: "tel",
            readOnly: this.props.readOnly,
          }} >
          <Label text="Phone" />
          <RequiredRule message="Phone is required" />
          <PatternRule
            message="The phone must have a correct phone format"
            pattern={/(?:(?:00|\+)?[0-9]{4})/}
          />
        </SimpleItem>
        {!hide_admin_options && (
          <SimpleItem
            dataField="is_reseller"
            editorOptions={{
              readOnly: this.readOnlyForResellersAndForUser(),
              onValueChanged: () => {
                console.log(this.props.user.is_reseller)
                // var hide_reseller_list = this.props.user.is_reseller
                // var hide_view_reseller = this.props.user.is_reseller
                // this.setState({
                //   hide_reseller_list: hide_reseller_list,
                //   hide_view_reseller: hide_view_reseller,
                // })
              },
            }} />
        )}
        {!hide_admin_options && (
          <SimpleItem
            dataField="reseller_programs"
            editorType="dxTextArea"
            editorOptions={{
              readOnly: this.readOnlyForResellersAndForUser(),
              height: 75,
            }} >            
          </SimpleItem>
        )}
        {!hide_admin_options && (
          <SimpleItem
            dataField="reseller_countries"
            editorType="dxTextArea"
            editorOptions={{
              readOnly: this.readOnlyForResellersAndForUser(),
              height: 75,
            }} />
        )}
        {!hide_admin_options && (
          <SimpleItem
            dataField="show_beta_sw"
            editorOptions={{
              readOnly: this.readOnlyForResellersAndForUser(),
              onValueChanged: () => {
                console.log(this.props.user.is_reseller)
              },
            }} />
        )}
        {!hide_admin_options && (
          <SimpleItem
            dataField="custom_config_en"
            editorOptions={{
              readOnly: this.readOnlyForResellersAndForUser(),
            }} >
            <Label text="Custom config" />
          </SimpleItem>
        )}        
        {!hide_admin_options && (
          <SimpleItem
          dataField="is_gas_specialist"
          editorOptions={{
              readOnly: this.readOnlyForResellersAndForUser(),
            }} >
          </SimpleItem>
        )}        
      </GroupItem>      
    )
  }
  companyFormItems() {
    return (
      <GroupItem caption="Company">
        <SimpleItem
          dataField="company_name"
          editorOptions={{
            readOnly: this.props.readOnly,
          }} >
          <StringLengthRule min={5} message="Company name must have at least 5 symbols" />
          <RequiredRule message="Company name is required" />
          <Label text="Name" />
        </SimpleItem>
        {/*
          <SimpleItem dataField="City" editorType="dxAutocomplete" editorOptions={this.cityEditorOptions}>
            <PatternRule pattern={/^[^0-9]+$/} message="Do not use digits in the City name" />
            <StringLengthRule min={2} message="City must have at least 2 symbols" />
            <RequiredRule message="City is required" />
          </SimpleItem>
        */}
        <SimpleItem
          dataField="company_country"
          editorType="dxSelectBox"
          editorOptions={{
            readOnly: this.props.readOnly,
            acceptCustomValue: !this.props.newUser,
            displayExpr: "name",
            valueExpr: "name",
            dataSource: _COUNTRIES,
            searchEnabled: true,
            onValueChanged: (e) => {
              var name = this.props.user.company_country
              var states = _COUNTRIES.find(item => item.name == name)?.states || []
              var states_view = [].concat("NONE", states.map(item => item.name))
              console.log("states_view", states_view)
              this.setState({
                states: states,
                states_view: states_view,
                cities: [],
                cities_view: [],
              })
            },
          }} >
          <RequiredRule message="Company country is required" />
          <Label text="Country" />
        </SimpleItem>
        <SimpleItem
          dataField="company_state"
          editorType="dxSelectBox"
          editorOptions={{
            readOnly: this.props.readOnly,
            acceptCustomValue: !this.props.newUser,
            items: this.state.states_view,
            searchEnabled: true,
            onValueChanged: (e) => {
              var name = this.props.user.company_state
              var cities = this.state.states.find(item => item.name == name)?.cities || []
              var cities_view = [].concat("NONE", cities.map(item => item.name))
              console.log("cities_view", cities_view)
              this.setState({
                cities: cities,
                cities_view: cities_view,
              })
            },
          }} >
          {/* <PatternRule pattern={/^[^0-9]+$/} message="Do not use digits in the company state name" /> */}
          {/* <StringLengthRule min={2} message="Company state must have at least 2 symbols" /> */}
          <RequiredRule message="Company state is required" />
          <Label text="State" />
        </SimpleItem>
        <SimpleItem
          dataField="company_city"
          editorType="dxSelectBox"
          editorOptions={{
            readOnly: this.props.readOnly,
            acceptCustomValue: !this.props.newUser,
            items: this.state.cities_view,
            searchEnabled: true,
          }} >
          {/* <PatternRule pattern={/^[^0-9]+$/} message="Do not use digits in the company city name" /> */}
          {/* <StringLengthRule min={2} message="Company city must have at least 2 symbols" /> */}
          <RequiredRule message="Company city is required" />
          <Label text="City" />
        </SimpleItem>
        <SimpleItem
          dataField="company_address"
          editorOptions={{
            readOnly: this.props.readOnly,
          }} >
          <StringLengthRule min={5} message="Company address must have at least 5 symbols" />
          <RequiredRule message="Company address is required" />
          <Label text="Address" />
        </SimpleItem>
        <SimpleItem
          dataField="company_vat_number"
          editorOptions={{
            readOnly: this.props.readOnly,
          }} >
          <RequiredRule message="Company VAT number is required" />
          <Label text="VAT number" />
        </SimpleItem>
      </GroupItem>
    )
  }
  informationFormItems() {

    var hide_admin_options = true
    if (this.props.newUser) {
      // questa vince su tutti
    } else if (this.props.isAdmin) {
      hide_admin_options = false
    } else {
      // in tutti gli altri casi non li faccio vedere
    }

    var hide_force_activation = true
    if (this.props.user.activation_date == NotActivatedString) {
      if (this.props.isAdmin || this.props.isReseller) {
        hide_force_activation = false   
      }
    }

    return (
      <GroupItem caption="Information">
        <SimpleItem
          dataField="registration_date"
          editorOptions={{
            readOnly: true
          }} />
        <SimpleItem
          dataField="activation_date"
          editorOptions={{
            readOnly: true
          }} />

        {!hide_force_activation && (
          <SimpleItem
            itemType="button"
            horizontalAlignment="right"
            buttonOptions={{
              text: 'Force activation',
              onClick: () => {
                this.props.btn_force_activation_click()
              },
            }} />
        )}
        {!hide_force_activation && (
          <EmptyItem />
        )}
        
        {!hide_admin_options && (
          <SimpleItem
            dataField="accesso_keygen"
            editorOptions={{
              readOnly: true
            }} >
            <Label text="Keygen" />
          </SimpleItem>
        )}
        {!hide_admin_options && (
          <SimpleItem
            dataField="is_admin"
            editorOptions={{
              readOnly: true
            }} />
        )}        
      </GroupItem>
    )
  }
  acceptFormItems() {
    if (this.props.hideAgrees) {
      return (
        <GroupItem caption="">
          <EmptyItem />
        </GroupItem>
      )
    }
    return (
      <GroupItem caption="Agreements">

        <SimpleItem>
          {/* https://www.privacypolicygenerator.info/  */}
          <a href={process.env.PUBLIC_URL + '/doc/privacy_policy.html'} target='_blank'>Privacy Policy</a>
        </SimpleItem>

        <SimpleItem
          dataField="accepted_privacy_policy"
          editorType="dxCheckBox"
          editorOptions={{
            text: 'I agree to the Privacy Policy',
            value: false,
          }} >
          <Label visible={false} />
          <CompareRule
            message="You must agree to the Privacy Policy"
            comparisonTarget={this.checkComparison} />
        </SimpleItem>

        <SimpleItem>
          {/* https://www.termsandconditionsgenerator.com/  */}
          <a href={process.env.PUBLIC_URL + '/doc/terms.html'} target='_blank'>Terms and Conditions</a>
        </SimpleItem>

        <SimpleItem
          dataField="accepted_terms"
          editorType="dxCheckBox"
          editorOptions={{
            text: 'I agree to the Terms and Conditions',
            value: false,
          }} >
          <Label visible={false} />
          <CompareRule
            message="You must agree to the Terms and Conditions"
            comparisonTarget={this.checkComparison} />
        </SimpleItem>

      </GroupItem>
    )
  }

  renderButtons() {
    var save_text = (this.props.newUser) ? "SUBMIT" : "SAVE"
    return (
      <>
        <Stack direction="row" spacing={1}>
          {this.props.readOnly && (this.props.newUser || this.props.isAdmin) && (
            <Button
              variant="outlined"
              size="medium"
              onClick={() => {
                this.props.btn_edit_click()
              }} >
              EDIT
            </Button>
          )}

          {!this.props.readOnly && !this.props.newUser && (
            <>
              {this.props.isAdmin && (
                <>
                  <Button 
                    variant="outlined"
                    color="secondary"
                    size="medium"
                    href="https://api.serviceapplications.net/_home/programsList"
                    target='_blank'
                    >
                    Program List
                  </Button>
                  <Button 
                    variant="outlined"
                    color="secondary"
                    size="medium"
                    href="https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3#Officially_assigned_code_elements"
                    target='_blank'
                    >
                    Country Codes
                  </Button>
                </>
              )}
              <Button
                variant="outlined"
                size="medium"
                onClick={() => {
                  this.props.btn_cancel_click()
                }} >
                CANCEL
              </Button>              
            </>
          )}

          {!this.props.readOnly && (
            <Button
              variant="contained"
              size="medium"
              onClick={() => {
                var res = this.form.current.instance.validate()
                if (res.isValid) {
                  this.props.btn_submit_click()
                } else {
                  console.log(res)
                }
              }} >
              {save_text}
            </Button>
        )}
        </Stack>
        <br />
      </>
    )
  }

  checkComparison() {
    return true;
  }  
  validatePassword(e, pwd2) {
    var pwd1 = e.value

    console.log(pwd1) // contiene la password nel campo corrente
    console.log(pwd2) 

    //console.log(this.props.user.password)
    //console.log(this.props.user.confirm_password)

    var p0 = true
    var p1 = true
    if (pwd1 === undefined)
      if (pwd1 === '')
        p0 = false
    if (pwd2 === undefined)
      if (pwd2 === '')
        p1 = false

    var res = false
    if (!p0 && !p1)
    {
      console.log("both 0")
      res = true
    }
    else if (!p0)
    {
      console.log("password 0")
      res = false
    }
    else if (!p1)
    {
      console.log("confirm_password 0")
      res = false
    }
    else if (pwd2 == pwd1)
    {
      console.log("password == confirm_password")
      res = true
    }
    else
    {
      console.log("password != confirm_password")
      res = false
    }
    return res
  }
}
